module.exports = __webpack_public_path__ + "files/46b96510f8b3befae964ad375b3b1d93.png";